// AI Generated Component
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { PAGE_PERFORMANCE_CONNECTION_PROFILES } from '@client/app/modules/page-performance/constants/page-performance-connection.-profiles';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { PipeService } from '@client/app/filters/pipe-transformation.service';
import { PagePerformanceLocationService } from '@client/app/modules/page-performance/services/page-performance-location/page-performance-location.service';
import { PagePerformanceProfileObsService } from '@client/app/modules/page-performance/services/profile-obs/profile-obs.service';
import { MonDialog } from '@client/app/modules/dialog-upgrade-wrapper/mon-dialog.service';
import { ProfilesRepoService } from '@client/app/services/api/page-performance/profiles-repo/profiles-repo.service';
import { safeClone } from '@client/app/shared/utils/object-utils';

@Component({
    selector: 'form-page-performance-profile',
    standalone: false,
    template: `
        <form #form="ngForm" name="form" class="form-horizontal" (ngSubmit)="!saving && form.valid && submit()">
            <div class="mon-dialog-header">
                <page-header [icon]="['PAGE_PERFORMANCE', 'PROFILE', 'ICON'] | monIcons"
                             [header]="'Profile' | translate"></page-header>
            </div>
            <div *ngIf="!getAvailableProfiles()">
              <div class="mon-dialog-body-with-footer">
                  <div class="card panel-monsido-card mx-6 mt-6">
                      <div class="card-header">
                          <h3 class="font-weight-300" translate>Profile details</h3>
                      </div>
                      <div class="card-body">
                          <form-field-input [required]="true"
                                            name="name"
                                            [(ngModel)]="model.name"
                                            [label]="'Name' | translate"
                                            [placeholder]="'Profile Name' | translate"
                                            type="text">
                          </form-field-input>
                          <form-field-textarea name="description"
                                               [(ngModel)]="model.description"
                                               [label]="'Description' | translate"
                                               [placeholder]="'Profile Description' | translate">
                          </form-field-textarea>
                          <div class="row">
                              <div class="offset-sm-8 col">
                                  <p class="text-grey" translate>NB! Connection Settings cannot be edited after save</p>
                              </div>
                          </div>
                          <div class="row">
                              <label class="col-sm-8 text-right text-bold">Device*</label>
                              <div class="col-sm-40">
                                  <div class="form-group row">
                                      <div class="col-12 d-flex" *ngFor="let device of devices; trackBy: trackByIndex">
                                          <button class="flex-fill btn btn-border-radius btn-secondary pt-7 pb-3"
                                                  type="button"
                                                  [disabled]="model.id"
                                                  [class.active]="model.device === device.value"
                                                  (click)="selectDevice(device.value)">
                                                <span class="fa-3x" [class]="device.icon" aria-hidden="true"></span><br/>
                                                <span class="mt-3 inline-block">{{device.name}}</span><br/><br/>
                                          </button>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="form-group">
                              <form-field-select returnValue="name"
                                                 [options]="connectionProfiles"
                                                 [disabled]="model.id"
                                                 [required]="true"
                                                 [label]="'Connection Profile' | translate"
                                                 [(ngModel)]="currentConnectionProfile"
                                                 name="connectionProfile">
                              </form-field-select>
                          </div>
                          <div class="form-group">
                              <form-field-select returnValue="key"
                                                 [options]="locations"
                                                 [disabled]="model.id"
                                                 [disableSearch]="true"
                                                 [required]="true"
                                                 [label]="'Measure from' | translate"
                                                 dropdownTemplate="app/modules/page-performance/forms/profile/dropdown-templates/location-item.html"
                                                 viewTemplate="app/modules/page-performance/forms/profile/dropdown-templates/location-item.html"
                                                 [(ngModel)]="currentLocation"
                                                 name="location">
                              </form-field-select>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="mon-dialog-footer text-right">
                  <button data-test="save-button" type="submit" [disabled]="saving || !form.valid" class="btn btn-border-radius btn-secondary">
                      <span class="fa-fw" [class]="getSpinnerIcon()"></span>
                      <span translate>Save</span>
                  </button>
              </div>
            </div>
        </form>
    `,
})
export class FormPagePerformanceProfileComponent implements OnInit {
    @Input() profile: any;
    @Input() monDialogId!: string;
    @ViewChild('form') form!: NgForm;

    saving = false;
    domains: any[] = [];
    model: any = {};
    devices: any[] = [];
    locations: any[] = [];
    currentLocation: any;
    currentConnectionProfile: any;
    connectionProfiles: any = [];
    profileRequest: any = {};

    constructor (
        private monDialog: MonDialog,
        private ng2PagePerformanceProfileService: ProfilesRepoService,
        private translateService: TranslateService,
        private ng2PipeService: PipeService,
        private pagePerformanceLocationService: PagePerformanceLocationService,
        private pagePerformanceProfileObsService: PagePerformanceProfileObsService,
    ) {}

    ngOnInit () {
        this.activate();
    }

    activate () {
        this.saving = false;
        this.domains = [];
        this.model = safeClone(this.profile || {});
        this.devices = [];
        this.locations = this.pagePerformanceLocationService.getLocations();
        this.model.device = this.model.device || 'desktop';
        this.currentLocation = this.model.location || this.locations[0].key;
        this.setupDevices();
        this.setupConnectionProfile();
    }

    submit () {
        this.saving = true;
        const model = safeClone(this.model);
        let promise: any;
        model.location = this.currentLocation;
        model.default_domain_ids = [];
        this.mergeConnectionProfile(this.currentConnectionProfile, model);
        if (this.model.id) {
            promise = this.ng2PagePerformanceProfileService.update(model).then((res: any) => {
                this.pagePerformanceProfileObsService.updateProfile(res);
                return res;
            });
        } else {
            promise = this.ng2PagePerformanceProfileService.create(model).then((res: any) => {
                this.pagePerformanceProfileObsService.addProfile(res);
                return res;
            });
        }
        promise.then(
            (profile: any) => {
                this.close(profile);
            },
            (err: any) => {
                this.saving = false;
            },
        );
    }

    getSpinnerIcon () {
        if (this.saving) {
            return 'fa-spin ' + this.ng2PipeService.get('monIcons')(['SPINNER', 'ICON']);
        }
        return '';
    }

    getAvailableProfiles () {
        return false;
    }

    trackByIndex (index: number, item: any): number {
        return index;
    }

    selectDevice (value: string) {
        this.model.device = value;
    }

    // PROTECTED

    private close (value: any) {
        this.monDialog.close(this.monDialogId, value);
    }

    private setupDevices () {
        this.devices = [
            {
                name: this.translateService.getString('Desktop'),
                value: 'desktop',
                icon: 'fas fa-desktop-alt',
            },
            {
                name: this.translateService.getString('Mobile'),
                value: 'mobile',
                icon: 'fas fa-mobile',
            },
        ];
    }

    private setupConnectionProfile () {
        this.currentConnectionProfile = null;
        this.connectionProfiles = PAGE_PERFORMANCE_CONNECTION_PROFILES;
        if (this.model.id) {
            const target = this.connectionProfiles.find((connectionProfile: any) => {
                for (const key in connectionProfile.settings) {
                    if (Object.prototype.hasOwnProperty.call(connectionProfile.settings, key) &&
                        connectionProfile.settings[key] !== this.model[key]) {
                        return false;
                    }
                }
                return true;
            });
            if (target) {
                this.currentConnectionProfile = target.name;
            }
        }
    }

    private mergeConnectionProfile (connectionProfileName: any, obj: any) {
        const connectionProfile = this.connectionProfiles.find((entry: any) => {
            return entry.name === connectionProfileName;
        });
        if (!connectionProfile) {
            return;
        }
        for (const setting in connectionProfile.settings) {
            if (Object.prototype.hasOwnProperty.call(connectionProfile.settings, setting)) {
                obj[setting] = connectionProfile.settings[setting];
            }
        }
    }
}
